'use strict';

const { payee } = require('../../../datatypes');
const { appendFilter } = require('../../../queries');
const addPayeesQueries = require('../../../queries/configs/Payees');

function Payees({ client, fspId, payerId }) {

  return {
    returnModel: {
      name: 'payee',
      model: payee,
    },
    baseUrl: `/fsps/${fspId}/payers/${payerId}/payees`,
    queriesFilter: appendFilter('payerId', payerId),
    create: function create(data, queryParams, cb) {
      return client.executeRequest('POST', this.baseUrl, {
        data,
        queryParams,
        cb,
        returnModel: this.returnModel,
      });
    },
  };

}

module.exports = addPayeesQueries(Payees);
